import type { PixelData } from "ag-psd";

export interface TrimmedPixels {
  /** X offset of the trimmed bitmap within the source, px. */
  left: number;
  /** Y offset of the trimmed bitmap within the source, px. */
  top: number;
  imageData: PixelData;
}

/** Crop full-canvas 8-bit RGBA to its non-transparent bounding box. `null` when fully transparent. */
export function trimTransparentPixels(pixels: PixelData): TrimmedPixels | null {
  const { width, height, data } = pixels;
  let left = width;
  let top = height;
  let right = -1;
  let bottom = -1;

  for (let y = 0; y < height; y++) {
    const rowStart = y * width * 4;
    for (let x = 0; x < width; x++) {
      if (data[rowStart + x * 4 + 3] !== 0) {
        if (x < left) left = x;
        if (x > right) right = x;
        if (y < top) top = y;
        if (y > bottom) bottom = y;
      }
    }
  }

  if (right < 0) return null;

  const trimmedWidth = right - left + 1;
  const trimmedHeight = bottom - top + 1;
  const trimmed = new Uint8ClampedArray(trimmedWidth * trimmedHeight * 4);
  for (let y = 0; y < trimmedHeight; y++) {
    const sourceStart = ((top + y) * width + left) * 4;
    trimmed.set(
      data.subarray(sourceStart, sourceStart + trimmedWidth * 4),
      y * trimmedWidth * 4,
    );
  }

  return {
    left,
    top,
    imageData: { width: trimmedWidth, height: trimmedHeight, data: trimmed },
  };
}
